module.exports = __webpack_public_path__ + "330a5307b6a0bf4fda029678f83359ca.svg";